import DesCreateLibraryViewModel from 'viewmodel/DesCreateLibraryViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCreateLibrary extends DesBaseCatalogAcc {
    constructor() {
        super(DesCreateLibraryViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {};
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale'];
    }
}

if (!window.customElements.get('des-create-library')) {
    window.customElements.define('des-create-library', DesCreateLibrary);
}
